import { FilterExpression } from "../../../Helpers/FilterExpressions/FilterExpression";

export interface MultiLineFilter {
    filterSourceId: string;
    filterSourceInfo: FilterSourceInfo;
    expression: FilterExpression;
}

export type MultiLineFilters = MultiLineFilter[];

export enum FilterSourceInfoType {
    DateRange,
    String,
    Items,
    PredefinedFilter,
    DefaultFilter,
}

export interface FilterDateRangeSource {
    type: FilterSourceInfoType.DateRange;
    startDate: string;
    endDate: string;
}

export interface FilterStringSource {
    type: FilterSourceInfoType.String;
    value: string;
}

export interface FilterPredefinedFilterSource {
    type: FilterSourceInfoType.PredefinedFilter;
    selectItemId: string;
}

export interface FilterItemsSource {
    type: FilterSourceInfoType.Items;
    values: string[][];
}

export interface FilterDefaultSource {
    type: FilterSourceInfoType.DefaultFilter;
}

export type MultiLineDefaultFilterUnsubscribeFn = (() => void) | undefined;

type FilterSourceInfo =
    | FilterDateRangeSource
    | FilterStringSource
    | FilterItemsSource
    | FilterPredefinedFilterSource
    | FilterDefaultSource;

export function getFilterBySourceId(filters: MultiLineFilters, id: string): MultiLineFilter | undefined {
    return filters.find(x => x.filterSourceId === id);
}

export function getAllPathsFromExpression(expression: FilterExpression): string[] {
    const result: string[] = [];
    const targetKey = "dataPath";
    function extractPathRecursively(obj: {} | [], currentPath?: string) {
        if (Array.isArray(obj)) {
            obj.forEach((i: {} | [], idx) => extractPathRecursively(i, `${currentPath}.${idx}`));
        } else if (typeof obj === "object") {
            Object.keys(obj).forEach(key => {
                if (key === targetKey) {
                    // @ts-ignore
                    result.push(obj[key] as string);
                }
                const path = `${currentPath ? currentPath + "." : ""}${key}`;
                // @ts-ignore
                return extractPathRecursively(obj[key] as string, path);
            });
        }
    }
    extractPathRecursively(expression);
    return result;
}
